import React from 'react';
import { Outlet } from 'react-router-dom';

const VendorsContent = () => {
  return <Outlet />;
};

export default VendorsContent;
